import axios from 'axios';
import CryptoJS from 'crypto-js';
import { postApi } from '../../lib/fetcher';
import { btoa, atob } from '../../lib/helpers';
import { dataIntervalSettlement } from '../params';

const settlementSetting = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      loadingAcquirer: false,
      loadingIssuer: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      item: null,
      insertProgress: 0,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      allAcquirer: null,
      allIssuer: null,
      totalPage: 0,

      requestData: null,
      percentage: 0,
      settlementStatus: false,
      countSameSettlement: 0,
      countDoneSettlement: 0,
      settlementId: null,
      countDataSettlement: 0,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setItem(state, { payload }) {
      state.item = payload.data.data;
    },

    setCategory(state, data) {
      state.allCategory = data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setLoadingAcquirer(state, loadingAcquirer) {
      state.loadingAcquirer = loadingAcquirer;
    },

    setLoadingIssuer(state, loadingIssuer) {
      state.loadingIssuer = loadingIssuer;
    },

    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setAcquirer(state, payload) {
      state.allAcquirer = payload;
    },

    setIssuer(state, payload) {
      state.allIssuer = payload;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },

    removeData(state, { index }) {
      state.totalData -= 1;
      state.allData = state.allData.filter((value) => value.id != index);
    },

    setIntervalSettlement(state, payload) {
      state.intervalSettlement = payload;
    },

    setSettlementData(state, payload) {
      state.settlementId = payload.export_id;
      state.countDataSettlement = parseInt(payload.count_data, 10);
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();

      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'id'} ${sort}`;

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/settlement_setting/settlement/index`;

      const addConfig = { cancelToken: axiosSource.token };
      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', {
          payload: responseData,
        });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async bulkSettlement(ctx, { date, id, options, search }) {
      if (ctx.state.settlementStatus) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Change Settlement in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );

        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'percentage',
      });
      ctx.commit('setStateVariable', {
        payload: true,
        variable: 'settlementStatus',
      });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameSettlement',
      });

      const data = JSON.stringify({
        id,
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Change settlement Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit('setStateVariable', {
          payload: false,
          variable: 'settlementStatus',
        });
      };

      const urlApi = `/index.php?r=api/v1/settlement_setting/settlement/settlement-checked`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        if (responseData.data.message != null) {
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: responseData.data.message,
              icon: 'mdi-alert',
              color: 'red',
            },
            { root: true }
          );
          ctx.commit('setStateVariable', {
            payload: false,
            variable: 'settlementStatus',
          });
        } else {
          ctx.commit('setSettlementData', responseData.data);
          const interval = setInterval(() => {
            ctx.dispatch('settlementStatus', {
              date,
              options,
              search,
            });
          }, dataIntervalSettlement);

          ctx.commit('setIntervalSettlement', interval);
        }
      } else {
        failed();
      }
    },

    async settlementStatus(ctx, { date, options, search }) {
      const data = JSON.stringify({
        export_id: ctx.state.settlementId,
        count_data: ctx.state.countDataSettlement,
        version: btoa(
          CryptoJS.SHA256(
            ctx.state.settlementId.toString() +
              ctx.state.countDataSettlement.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        clearInterval(ctx.state.intervalSettlement);
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Change settlement Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit('setStateVariable', {
          payload: false,
          variable: 'settlementStatus',
        });
      };

      try {
        const urlApi = `/index.php?r=api/v1/settlement_setting/settlement/status-checked`;

        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code == '10') {
          clearInterval(ctx.state.intervalSettlement);
          ctx.commit('setStateVariable', {
            payload: 100,
            variable: 'percentage',
          });
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: 'Settlement Done !',
              icon: 'mdi-check-circle',
              color: 'green',
            },
            { root: true }
          );
          ctx.commit('setStateVariable', {
            payload: false,
            variable: 'settlementStatus',
          });
          ctx.dispatch('getData', {
            date,
            page: options.page,
            itemsPerPage: options.itemsPerPage,
            sortBy: options.sortBy,
            sortDesc: options.sortDesc,
            search,
          });
        } else if (responseData.code == '302') {
          failed();
        } else {
          const totalDataDone = parseInt(responseData.data.count_success, 10);

          ctx.commit('setStateVariable', {
            payload: (totalDataDone / ctx.state.countDataSettlement) * 100,
            variable: 'percentage',
          });
          if (ctx.state.countDoneSettlement != totalDataDone) {
            ctx.commit('setStateVariable', {
              payload: totalDataDone,
              variable: 'countDoneSettlement',
            });
            ctx.commit('setStateVariable', {
              payload: 0,
              variable: 'countSameSettlement',
            });
          } else {
            ctx.commit('setStateVariable', {
              payload: ctx.state.countSameSettlement + 1,
              variable: 'countSameSettlement',
            });
          }
          if (ctx.state.countSameSettlement > 2) {
            failed();
          }
        }
      } catch (error) {
        failed();
      }
    },
  },
};

export default settlementSetting;
